import dayjs from 'dayjs';
import { useMemo, useState } from 'react';
import { PostSchema } from '@ametista-ai/api-schema';
import { Box, Group, Stack, Text, UnstyledButton } from '@mantine/core';
import { RichEditorReadOnly } from '@/components/RichEditor/RichEditorReadOnly';
import { UserBadge } from '@/components/Users/UserBadge';
import { usePostActivityLogs } from '@/queries/activityLogs/usePostActivityLogs';

export const PostContentHistory = ({ post }: { post: PostSchema }) => {
  const { data } = usePostActivityLogs(post.id);
  const activities = data?.data;

  const [selectedVersionId, setSelectedVersionId] = useState<string | null>(null);

  const activitiesWithContentChanges = useMemo(() => {
    return activities?.filter(
      (activity) =>
        ['update', 'create'].includes(activity.action) &&
        activity.modelType === 'Post' &&
        activity.payload?.attributes.content
    );
  }, [activities]);

  const selectedVersion = useMemo(() => {
    return (
      activitiesWithContentChanges?.find((activity) => activity.id === selectedVersionId) ??
      activitiesWithContentChanges?.[0]
    );
  }, [activitiesWithContentChanges, selectedVersionId]);

  return (
    <Stack gap="sm">
      <Group mih={300} align="flex-start" wrap="nowrap">
        <Box flex={1}>
          <RichEditorReadOnly
            content={(selectedVersion?.payload?.attributes.content as string | undefined) ?? null}
          />
        </Box>
        <Stack gap="sm" w={200}>
          {activitiesWithContentChanges?.map((activity) => {
            const user = activity.user;
            return (
              <UnstyledButton key={activity.id} onClick={() => setSelectedVersionId(activity.id)}>
                <Stack gap="3xs">
                  <Text size="xs">{dayjs(activity.createdAt).format('L LT')} </Text>
                  {user && (
                    <Group gap="2xs">
                      <UserBadge
                        userId={user.id}
                        displayName={user.displayName}
                        image={user.image}
                      />
                      <Text size="xs">{user.displayName}</Text>
                    </Group>
                  )}
                </Stack>
              </UnstyledButton>
            );
          })}
        </Stack>
      </Group>
    </Stack>
  );
};
